// extracted by mini-css-extract-plugin
export default {"paymentForm":"PaymentForm_paymentForm__5GCHI","detailFieldsCard":"PaymentForm_detailFieldsCard__fNVRO","clientFieldsValuesInput":"PaymentForm_clientFieldsValuesInput__6h20O"};